import { useContext } from "react";
import { AudioContext, type AudioContextType } from "../contexts/AudioContext";

export function useAudioContext(): AudioContextType {
  const context = useContext(AudioContext);
  if (context === undefined) {
    throw new Error("useAudioContext must be used within an AudioProvider");
  }
  return context;
}
